<template>
  <div class="cookie-bar">
    <span>
      Unsere Seite verwendet Cookies und ähnliche Technologien. Mit der Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.
      Mehr Informationen dazu finden Sie in unserer &nbsp;
    </span>
    <router-link to="/datenschutz">Datenschutzerklärung</router-link>
    <button class="cookie-bar__button" @click="cookiesAccepted">OK</button>
  </div>
</template>

<script>
export default {
  name: "CookieBar",
  methods: {
    cookiesAccepted() {
      this.$emit("cookies-accepted");
    }
  }
};
</script>

<style scoped lang="scss">
.cookie-bar {
  position: fixed;
  max-width: 327px;
  right: 0;
  bottom: 0;
  border-radius: 8px;
  box-shadow: 0 6px 20px -4px rgba(20, 20, 20, 0.16),
    0 2px 8px 0 rgba(10, 10, 10, 0.04);
  background-color: #ffffff;
  padding: 16px;
  margin: 24px;
  text-align: left;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #0d0d0d;

  &__button {
    display: block;
    padding: 8px 12px;
    border-radius: 4px;
    border: solid 2px #3687da;
    line-height: 14px;
    //font-family: Soleil;
  font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.7px;
    color: #3687da;
    margin-top: 8px;
  }
}

@media (max-width: 767px) {
  .cookie-bar {
    left: 0;
    max-width: unset;
  }
}
</style>
